import React from 'react'
import PropTypes from 'prop-types'

import './QuoteBlock.css'

const QuoteBlock = ({ quoteText, children }) => {
  return (
    <div className="fmbm-quoteblock">
      <blockquote className="wow slideInUp">{quoteText}</blockquote>
      {children}
    </div>
  )
}

QuoteBlock.propTypes = {
  quoteText: PropTypes.string.isRequired,
}

export default QuoteBlock



// WEBPACK FOOTER //
// ./src/Components/QuoteBlock/QuoteBlock.js